import { get } from 'lodash';

export const getAvailablePoints = (state, page) => {
  return get(state, `pages[${page}]`, []).length * get(state, 'pointsPerStatement');
};

export const getAnswersOfUser = (state, evalId, page) => {
  const pageQuestions = get(state, `pages[${page}]`, []);
  const allAnswers = Array.from(Object.values(get(state, `answers.${evalId}`, {})));

  const filteredAnswers = allAnswers.filter(item =>
    pageQuestions.includes(parseInt(item.statement_id)),
  );

  return filteredAnswers;
};

export const getSpentPoints = (state, userId, page) => {
  const pageAnswers = getAnswersOfUser(state, userId, page);

  return pageAnswers.reduce((sum, answer) => {
    return sum + answer.value;
  }, 0);
};

export const getIgnoredQuestionsValue = (state, userId, page, pointsPerStatement) => {
  const pageAnswers = getAnswersOfUser(state, userId, page);
  const ignoredQuestionsValue = pageAnswers.filter(answer => !answer.enabled);

  return ignoredQuestionsValue.length * pointsPerStatement;
};
